import React, {useState} from 'react'
import Button from '@components/Button'
import ErrorBox from '@components/ErrorBox'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import useLoyaltyCode from '@page-components/Checkout/CheckoutV2/LoyaltyProgram/hooks/useLoyaltyCode'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'
import {Field} from 'simple-react-form'

import RecoverPassword from './recoverPassword'
import ValidateUser from './validateUser'

export default function SpoonityForm({
  email,
  activeLoyalty,
  isUserLoggedIn
}: {
  email: string
  activeLoyalty: any
  isUserLoggedIn: boolean
}) {
  const {submit, errorMessage, isValid} = useLoyaltyCode()
  const [credentials, setCredentials] = useState<{email: string; password: string}>({
    email: email ?? '',
    password: ''
  })
  const [localLoading, setLocalLoading] = useState<boolean>(false)
  const [localError, setLocalError] = useState<string>(null)
  const [showVerificationCode, setShowVerificationCode] = useState<boolean>(false)
  const [loyaltyAuthenticatedToken, setLoyaltyAuthenticatedToken] = useState<string>(null)
  const mutate = useMutate()

  async function submitLoyalty() {
    try {
      setLocalError(null)
      setLocalLoading(true)
      const {setAuthLoyalty} = await mutate({
        mutation: gql`
          mutation setAuthLoyalty($credentials: JSON) {
            setAuthLoyalty(credentials: $credentials)
          }
        `,
        variables: {credentials}
      })
      if (setAuthLoyalty) {
        //We need to check if user is verified
        setLoyaltyAuthenticatedToken(setAuthLoyalty)
      }
    } catch (error) {
      setLocalError(error.message)
    } finally {
      setLocalLoading(false)
    }
  }

  const error = localError || errorMessage || ''

  return (
    <div className="w-full pt-10">
      <Field
        fieldName="email"
        type={Text}
        value={credentials.email}
        disabled={true}
        label="Correo"
      />
      {loyaltyAuthenticatedToken || isUserLoggedIn ? null : (
        <>
          <Field
            fieldName="password"
            fieldType="password"
            type={Text}
            value={credentials.password}
            disabled={loyaltyAuthenticatedToken ? true : false}
            label="Contraseña"
            onChange={password => setCredentials({...credentials, password})}
          />
          <Button
            fullWidth
            primary
            onClick={async () => {
              await submitLoyalty()
            }}
            disabled={!credentials.email || !credentials.password || loyaltyAuthenticatedToken}
            loading={localLoading}>
            Acceder
          </Button>
        </>
      )}

      <RecoverPassword activeLoyalty={activeLoyalty} email={email} />
      <br />
      {loyaltyAuthenticatedToken && !showVerificationCode ? (
        <ValidateUser
          loyaltyAuthenticatedToken={loyaltyAuthenticatedToken}
          submit={submit}
          email={credentials.email}
          setShowVerificationCode={setShowVerificationCode}
        />
      ) : null}
      {error || !isValid ? <ErrorBox message={error} /> : null}
    </div>
  )
}
